import React from 'react';

export const LandingLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="landing-page flex min-h-screen w-full flex-col items-center bg-white font-sans antialiased dark:bg-black">
    {/* No navbar - logo-only centered design for maximum conversion focus */}
    <main className="flex w-full flex-1 flex-col items-center px-0 pb-0 pt-0">{children}</main>
  </div>
);
